import {
  Button,
  FileUpload,
  FileUploadFile,
  Modal,
  Text,
} from '@bbl-digital/snorre-v2'
import ArchiveFilePickerButton from '../ArchiveFilePicker/Button'
import { useFileuploadPickerContext } from '../context/useFileuploadPickerContext'
import { mapFileUploadFiles } from '../utils/mapper'
import { Step } from '../types/types'
import PickerFileList from '../components/PickerFileList'

const LocalFilePicker = () => {
  const {
    onChange,
    onCloseModal,
    setStep,
    onSaveModal,
    files,
    maxsizeInBytes,
    accept,
    reject,
  } = useFileuploadPickerContext()

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLDivElement>,
    files: FileUploadFile[]
  ): void => {
    const mapped = mapFileUploadFiles(files)
    onChange(mapped)
  }

  const anyInvalidFiles = files.some((file) => file.validation !== undefined)

  return (
    <>
      <Modal.Header>Legg til vedlegg</Modal.Header>
      <Modal.Block className="flex flex-col space-y-2">
        <Text>
          Last opp fil lokalt fra egen enhet, eller velg fra styrets arkiv
        </Text>
        <div className="flex justify-between gap-2">
          <div className="border rounded-md flex-1">
            <FileUpload
              label="Klikk for å laste opp lokale filer"
              value={[]}
              accept={accept}
              reject={reject}
              onChange={handleFileChange}
              maxSizeBytes={maxsizeInBytes}
            />
          </div>
          <div className="flex-1 border rounded-md">
            <ArchiveFilePickerButton onClick={() => setStep(Step.ARCHIVE)} />
          </div>
        </div>

        <PickerFileList files={files} />
      </Modal.Block>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCloseModal}>
          Avbryt
        </Button>
        <Button
          disabled={files.length === 0 || anyInvalidFiles}
          onClick={onSaveModal}
        >
          Legg til
        </Button>
      </Modal.Footer>
    </>
  )
}
export default LocalFilePicker
